import React from "react";
import "./WhyUs.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useHomeSection } from "../../../../context/HomePageContext";
import { useServiceSection } from "../../../../context/ServicePageContext";
import { getCardsFromSection } from "../../../../services/contentApi";
import { useCmsPageSection } from "../../../../hooks/useCmsPageSection";
import { stripRichText } from "../../../../utils/richText";

import icon1 from "../../../../assets/icons/whyus/icon1.svg";
import icon2 from "../../../../assets/icons/whyus/icon2.svg";
import icon3 from "../../../../assets/icons/whyus/icon3.svg";
import icon4 from "../../../../assets/icons/whyus/icon4.svg";

const icons = [icon1, icon2, icon3, icon4];

const WhyUs = () => {
  const service = useServiceSection("whyus");
  const home = useHomeSection("whyus");
  const fetched = useCmsPageSection("home", "whyus", {
    skip: service.fromServicePage || home.fromHomePage,
  });

  const section = service.fromServicePage
    ? service.section
    : home.fromHomePage
      ? home.section
      : fetched.section;
  const loading = service.fromServicePage
    ? service.loading
    : home.fromHomePage
      ? home.loading
      : fetched.loading;

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const cards = getCardsFromSection(section, 4);

  return (
    <section className="whyus">
      <div className="whyus-top">
        <CmsText
          content={fields.subtitle}
          as="p"
          className="whyus-subtitle"
        />
        <CmsText content={fields.title} as="h2" className="whyus-title" />
        <RichTextContent
          content={fields.description}
          className="whyus-description"
        />
      </div>

      <div className="whyus-bottom">
        {cards.map((card, i) => (
          <div className="why-card" key={i}>
            <img src={icons[i]} alt={stripRichText(card.title)} className="iconwhc" />
            <CmsText content={card.title} as="h3" />
            <RichTextContent content={card.description} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUs;
